/**
 * Položky lišty Testovacích nástrojů. Vytaženo z `TestingLayout`, aby stejný
 * seznam mohla použít i indexová routa `/testing` — ta dřív mířila natvrdo na
 * API Tools a při skryté feature poslala uživatele na prázdnou stránku.
 *
 * Čistý modul bez Reactu → testovatelné.
 */
export interface TestingSection {
  to: string;
  labelKey: string;
  feature: string;
  /** Nástroj dává smysl jen s tímhle konektorem (mirror legacy `@ConditionalOnClass`). */
  connectorType?: string;
}

/** API Tools jsou nejpoužívanější nástroj → první v liště (a výchozí cíl indexu). */
export const TESTING_SECTIONS: TestingSection[] = [
  { to: "/testing/api-tools", labelKey: "apitools.nav", feature: "testing.api-tools" },
  { to: "/testing/soap-tools", labelKey: "soaptools.nav", feature: "testing.api-tools", connectorType: "ECOBRA_SOAP" },
  { to: "/testing/echannels-tools", labelKey: "echtools.nav", feature: "testing.api-tools", connectorType: "CSOB_ECHANNELS" },
  // Bez `connectorType` — nástroj stojí nad sdílenou krypto vrstvou, ne nad konektorem.
  { to: "/testing/asym-tools", labelKey: "asymtools.nav", feature: "testing.asym-tools" },
  { to: "/testing/activation", labelKey: "testing.activation", feature: "testing.test-activation" },
  { to: "/testing/otp-password", labelKey: "testing.otp", feature: "testing.test-otp-password" },
  { to: "/testing/device-replacement", labelKey: "testing.dr", feature: "testing.test-device-replacement" },
  { to: "/testing/admin", labelKey: "testing.admin", feature: "testing.test-admin" },
  { to: "/testing/loadtest", labelKey: "loadtest.nav", feature: "testing.loadtest-generator" },
  { to: "/testing/scenarios", labelKey: "scenarios.nav", feature: "testing.loadtest-generator" },
];

/** Feature IDs všech testovacích nástrojů — nav položka se zobrazí, když je aspoň jeden viditelný. */
export const TESTING_FEATURES = [...new Set(TESTING_SECTIONS.map((s) => s.feature))];

export function visibleTestingSections(
  show: (feature: string) => boolean,
  hasConnector: (connectorType: string) => boolean,
): TestingSection[] {
  return TESTING_SECTIONS.filter((s) => show(s.feature) && (!s.connectorType || hasConnector(s.connectorType)));
}
